import React from 'react'
import './index.less'
import {
  getUserInfo,
  getDeviceInfo,
  jumpToUser,
  jumpToRoom,
  jumpToWallet,
  jumpToStore,
  jumpToUserStore,
  shareToLink,
  shareToWhatsapp,
  closeWebViewPage,
  closeWebview,
  chooseImage,
  uploadFile,
} from 'src/helper/webviewFun'
import fileType from 'src/helper/fileType'
import VConsole from 'src/helper/vconsole'
import SVGA from 'svgaplayerweb'
import http from 'src/helper/http'

export default class extends React.Component {
  async componentWillMount() {}

  constructor(props) {
    super(props)
  }

  state = {
    UserInfo: '',
    DeviceInfo: '',
    AppVersion: '',
    pic: ['https://img.chatie.live/app/man.jpg', 'https://img.chatie.live/app/man.jpg'],
    uploadpic: [],
  }

  get1 = async () => {
    let d = await getUserInfo()
    console.log(222222222, d)
    this.setState({
      UserInfo: d,
    })
  }

  async get2() {
    let d = await getDeviceInfo()
    console.log(333333, d)
    this.setState({
      DeviceInfo: d,
    })
  }

  async get3() {
    jumpToUser(10000)
  }

  async get4() {
    jumpToRoom(10000)
  }

  async get5() {
    jumpToWallet(0)
  }

  async get6() {
    jumpToWallet(1)
  }

  async get7() {
    jumpToStore(0)
  }

  async get8() {
    jumpToStore(1)
  }

  async get9() {
    jumpToUserStore(0)
  }

  async get10() {
    jumpToUserStore(1)
  }

  async get11() {
    shareToLink('https://h5-activity.yayya.live')
  }

  async get12() {
    shareToWhatsapp('这是分享的内容')
  }

  async get13(aa) {
    console.log('选择图片')

    let map = {
      count: 3, // 可以选择的最多数量
      sizeType: 'compressed', // 大小压缩 original/compressed
      mp4Enabled: false, // 是否可以选择mp4，true等于可以同时选mp4和图片
    }
    console.log('选择图片提交的参数', map)
    chooseImage(map, (d) => {
      // 只能把回调放在这里，因为是异步回调，无法改成async await
      console.log('选择图片回调', d)
      this.setState({
        pic: d || [],
      })
    })
  }

  async get132(aa) {
    console.log('选择图片')

    let map = {
      count: 3, // 可以选择的最多数量
      sizeType: 'compressed', // 大小压缩 original/compressed
      mp4Enabled: true, // 是否可以选择mp4，true等于可以同时选mp4和图片
    }
    console.log('选择图片提交的参数', map)
    chooseImage(map, (d) => {
      // 只能把回调放在这里，因为是异步回调，无法改成async await
      console.log('选择图片回调', d)
      this.setState({
        pic: d || [],
      })
    })
  }

  async get16(url) {
    console.log('pic的图片数量' + this.state.pic.length)
    if (this.state.pic.length > 0) {
      let req = []
      for (let i = 0; i < this.state.pic.length; i++) {
        req.push({
          filePath: this.state.pic[i].path,
          fileType: fileType.get(this.state.pic[i].path),
        })
      }
      // console.log("选择的图片数量" + req.length)
      console.log('调用dsBridge上传前', req)

      console.log('上传之前的图片地址')
      for (let i = 0; i < req.length; i++) {
        console.log(req[i].filePath + ' 文件类型 ' + req[i].fileType)
      }

      uploadFile(req, (d) => {
        console.log('上传之后的图片地址', d)
        this.setState({
          uploadpic: d || [],
        })
        // for (let i = 0; i < d.length; i++) {
        //   console.log(d[i].filePath+" 对应上传网址是 " + d[i].url)
        // }

        // uploadpic
      })
    } else {
      console.log('没有选择图片')
    }
  }

  async get14() {
    closeWebViewPage()
  }

  async get15() {
    closeWebview()
  }

  async get17() {
    let d = await getAppVersion()
    this.setState({
      AppVersion: d,
    })
  }

  opense = () => {
    let { userAtv } = this.state
    var player = new SVGA.Player('#DAsd')
    var parser = new SVGA.Parser('#DAsd')
    parser.load('/img/app/week/twns.svga', function (videoItem) {
      player.setVideoItem(videoItem)
      player.setImage(userAtv, 'img_206')
      player.startAnimation()
    })
  }

  componentDidMount() {
    http.post('/web/MyAccountInfo', { uid: 106879 }).then((res) => {
      console.log(res)
      this.setState({ userAtv: res.res.avatarurl })
    })
  }
  render() {
    let { UserInfo, DeviceInfo, AppVersion } = this.state

    let info = {
      rank: 1,
      avatar: '/img/activity/worldcup/banner.png',
      nickname: 1,
      uid: 1,
      gold: 1,
    }
    let styles = {
      themeFontColor: 'blue',
      bg: '/img/activity/worldcup/gold_bor.png',
    }

    return (
      <div className="test">
        <button
          onClick={() => {
            this.get1()
          }}
        >
          用户信息(点击后空白，正常){UserInfo}
        </button>
        <br />
        <br />

        <button
          onClick={() => {
            this.get2()
          }}
        >
          设备信息(点击后空白，正常){DeviceInfo}
        </button>
        <br />
        <br />

        <button
          onClick={() => {
            this.get3()
          }}
        >
          跳转到用户10000
        </button>
        <br />
        <br />

        <button
          onClick={() => {
            this.get4()
          }}
        >
          跳转到房间10000
        </button>
        <br />
        <br />

        <button
          onClick={() => {
            this.get5()
          }}
        >
          跳转到钱包金币
        </button>
        <br />
        <br />

        <button
          onClick={() => {
            this.get6()
          }}
        >
          跳转到钱包宝石
        </button>
        <br />
        <br />

        <button
          onClick={() => {
            this.get7()
          }}
        >
          跳转到头饰
        </button>
        <br />
        <br />

        <button
          onClick={() => {
            this.get8()
          }}
        >
          跳转到坐骑
        </button>
        <br />
        <br />

        <button
          onClick={() => {
            this.get9()
          }}
        >
          跳转到个人头饰
        </button>
        <br />
        <br />

        <button
          onClick={() => {
            this.get10()
          }}
        >
          跳转到个人坐骑
        </button>
        <br />
        <br />

        <button
          onClick={() => {
            this.get11()
          }}
        >
          复制链接
        </button>
        <br />
        <br />

        <button
          onClick={() => {
            this.get12()
          }}
        >
          分享到whatsapp
        </button>
        <br />
        <br />

        <button
          onClick={() => {
            this.get13()
          }}
        >
          选择图片
        </button>
        <br />
        <br />
        <button
          onClick={() => {
            this.get132()
          }}
        >
          选择图片和视频
        </button>
        <br />
        <br />

        {this.state.pic &&
          this.state.pic &&
          this.state.pic.length > 0 &&
          this.state.pic.map((i, v) => {
            return (
              <img
                src={
                  i && i.imageData && i.imageData.indexOf('base64') > 0
                    ? i.imageData
                    : 'data:image/png;base64,' + i.imageData
                }
              />
            )
          })}

        <br />

        <button
          onClick={() => {
            this.get16()
          }}
        >
          开始上传
        </button>
        <br />
        <br />

        {this.state.uploadpic &&
          this.state.uploadpic &&
          this.state.uploadpic.length > 0 &&
          this.state.uploadpic.map((v, i) => {
            return <img src={v} />
          })}

        <button
          onClick={() => {
            this.get14()
          }}
        >
          关闭
        </button>
        <br />
        <br />

        <button
          onClick={() => {
            this.get15()
          }}
        >
          半屏关闭
        </button>
        <br />
        <br />

        <button
          onClick={() => {
            this.opense()
          }}
        >
          播放动画
        </button>
        <br />
        <br />
        {/* <button onClick={() => { this.get17() }}>版本信息{AppVersion}</button><br /><br /> */}

        {/*
        <MyInfo
          info={info}
          styles={styles}
        /> */}

        {/* <img src='https://d57d7hz6h6y0z.cloudfront.net/…ebp?x-oss-process=image/resize,m_fill,h_480,w_480'></img> */}
        <div
          className="DAsd"
          id="DAsd"
          style={{ width: '4rem', height: '4rem', margin: '0 auto' }}
          src="/img/app/week/twns.svga"
        ></div>

        <div className="clip-path"></div>
        <div className="img-night">
          <div className="item"></div>
          <div className="item"></div>
          <div className="item"></div>
          <div className="item"></div>
          <div className="item"></div>
          <div className="item"></div>
          <div className="item"></div>
          <div className="item"></div>
          <div className="item"></div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/test/webview/index.js